import { render, staticRenderFns } from "./MyResellerCert.vue?vue&type=template&id=efa0dbfe&scoped=true&"
import script from "./MyResellerCert.vue?vue&type=script&lang=js&"
export * from "./MyResellerCert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa0dbfe",
  null
  
)

export default component.exports